<script>
export default {
  name: 'mixin-style',
  props: {
    height: {
      type: Number,
      default: null,
    },
    width: {
      type: Number,
      default: null,
    },
    paddingRight: {
      type: Number,
      default: 0,
    },
    borderTopWidth: {
      type: Number,
      default: 0,
    },
    borderRightWidth: {
      type: Number,
      default: 0,
    },
    borderBottomWidth: {
      type: Number,
      default: 0,
    },
    borderLeftWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      borderColorDefault: '#dddddd',
      backgroundColorFocused: '#eeeeee',
      backgroundColorFocusedError: '#d99998',
    }
  },
}
</script>



// WEBPACK FOOTER //
// style.vue?13dd40ca